import {bindable, customElement, inject} from 'aurelia-framework';
import 'select2';
import 'select2/dist/css/select2.min.css'
import {Client} from "../api/client";
import $ from "jquery";

import "./tag-element.less";

@inject(Element, Client)
@customElement('sio-tag-input')
export class TagElement {

    @bindable({defaultBindingMode: 2}) value;
    @bindable options;
    @bindable property;

    element;
    client;

    select;

    constructor(element, client) {
        this.element = element;
        this.client = client;
    }

    attached() {
        $(this.select).on('change', this.change.bind(this));
        $(this.select).on('select2:unselect', this.change.bind(this));
    }

    detached() {
        $(this.select).off('change');
        $(this.select).off('select2:unselect');
        if (this.options?.showClear) {
            $(this.select).next('.select2-container').next('a').remove();
        }
    }

    bind() {
        const options = {
            language: 'de',
            tags: true,
            tokenSeparators: [','],
            data: this.value,
            selectOnClose: false // Must be false, because otherwise selects even on "Escape" button press
        };

        if (this.options && this.options.hasOwnProperty('dataSource')) {
            options.ajax = {
                delay: 250,
                transport: (params, success, failure) => {
                    let url = this.options.dataSource;

                    if (params && params.data) {
                        url += '?' + $.param(params.data);
                    }

                    this.client.get(url)
                        .then(data => success(data))
                        .catch(error => failure(error))
                }
            };
        } else if (this.options?.modelId != null || this.options?.modelIdProperty != null) {
            // Use modelIdProperty if available, otherwise fallback to modelId
            const modelIdIdentifier = this.options?.modelIdProperty ?? this.options.modelId;
            options.ajax = {
                delay: 250,
                transport: (params, success, failure) => {
                    let url = 'form/distinct/' + modelIdIdentifier + '/';

                    url += this.options.tagsProperty ?? this.property;

                    if (params && params.data) {
                        url += '?' + $.param(params.data);
                    }

                    this.client.get(url)
                        .then(data => success(data))
                        .catch(error => failure(error))
                }
            };

            // Distinct values
        }

        $(this.select).select2(options);

        this.valueChanged();

        if (this.options?.showClear) {
            const $container = $(this.select).next('.select2-container');
            $('<a>')
                .text('Alle abwählen')
                .css({
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                })
                .on('click', () => {
                    this.value = [];
                    $(this.select).val([]).trigger('change');
                })
                .insertAfter($container);
        }
    }

    valueChanged() {
        $(this.select).val(this.value).trigger('change.select2');
    }

    change(e) {
        let newValue = $(e.currentTarget).val();

        if (newValue === '') {
            newValue = [];
        }

        this.value = newValue;
    }
}
